import { Box } from '@oresundsbron/bridge-ui';
import { usePageCorporateFullWidth } from '../hooks/usePageCorporateFullWidth';
import { usePageCorporateFullWidthContent } from '../hooks/usePageCorporateFullWidthContent';
import { SEOMetadata } from '~/components/SEOMetadata';
import { CorporateMeny } from './Corporate/Meny';
import {
  CorporateBanner,
  CorporateContentRenderer,
  CorporateSubFooter,
} from './Corporatev2';
import { Breadcrumbs } from './Breadcrumbs';

type PageCorporateFullWidthProps = {
  id: string;
};

export const PageCorporateFullWidth = ({ id }: PageCorporateFullWidthProps) => {
  const { page, seoMetadata } = usePageCorporateFullWidth({ id });
  const { data } = usePageCorporateFullWidthContent({ id });

  if (!page) {
    return null;
  }

  if (!data) {
    return null;
  }
  const { banner, sys } = page;
  const { content } = data;

  return (
    <>
      <Box as="main">
        <SEOMetadata items={seoMetadata} customJsonLd={page?.jsonLd} />
        {page.leftNavigation && (
          <Breadcrumbs
            id={sys?.id}
            className="z-10 col-start-2 px-4 pb-2 pt-6 sm:pb-6"
          />
        )}
        {banner?.title && <CorporateBanner content={banner} />}

        {page.leftNavigation ? (
          <div className="mx-auto grid max-w-7xl grid-cols-12">
            <CorporateMeny className="col-span-full px-4 md:col-span-3 md:mt-8" />
            <Box className="col-span-full md:col-span-9">
              <div className="mb-6 mt-8 grid gap-8 sm:mt-20 sm:gap-16">
                {content?.map((item) => (
                  <CorporateContentRenderer content={item} key={item.sys?.id} />
                ))}
              </div>
            </Box>
          </div>
        ) : (
          <div className="mb-6 mt-8 grid gap-8 sm:mb-20 sm:mt-16 sm:gap-16">
            {content?.map((item) => (
              <CorporateContentRenderer content={item} key={item.sys?.id} />
            ))}
          </div>
        )}
      </Box>

      <CorporateSubFooter />
    </>
  );
};
